// extracted by mini-css-extract-plugin
module.exports = {"confirmDialogue":"ConfirmDialog_confirmDialogue__1CxdD","btn":"ConfirmDialog_btn__QDQpf"};